exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".rss-feed-switch label{font-weight:600!important;color:#212121!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Request/activity.vue"],"names":[],"mappings":"AACA,uBACE,0BAA4B,AAC5B,uBAA0B,CAC3B","file":"activity.vue","sourcesContent":["\n.rss-feed-switch label {\n  font-weight: 600 !important;\n  color: #212121 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61ff64d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Request/activity.vue
// module id = 1159
// module chunks = 3 4